import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
  BO_ACCESS_PORTAL_REPORT_URL,
  COMPANY_FETCH_URL, WORKER_TYPES_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import { IconButton } from "@material-ui/core";
import ExcelLogo from "assets/img/excel_icon.svg";
import PdfLogo from "assets/img/pdf_icon.svg";
import { useNotifyContext } from "components/Notify";



let model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "company", label: "Company", type: "string" },
  { id: "zone", label: "Zone", type: "string" },
  { id: "region", label: "Region",type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "attendance", label: "Attendance Record: View", type: "string" },
  { id: "sos", label: "SOS Record: View", type: "time" },
  { id: "hq", label: "HQ", type: "time" },
  { id: "role", label: "Role", type: "string" },
  

  
];



const boAccessPortalDetails = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const setNotify = useNotifyContext();


  const details = useLocation();
  const URLS = {
    BO_REPORT: "report/backoffice-access-detailed",
  };
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');

  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };

  const filterFields = [

    {
      type: "datepicker",
      label: "From User Access Date ",
      name: "from",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To User Access Date ",
      name: "to",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },
     

    
      {
        type: "reactselect",
        name: "company",
        label: "Company",
        proxyUrl: COMPANY_FETCH_URL,
        paginated: true,
        required: true,

        
  
      },
    
   
    
    
 
    
    
    
  ];
  
 

  const validationSchema = Yup.object({
    from: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
    to: Yup.date().required("Date is required").nullable().typeError("Invalid To Last Login Date"),
    company: Yup.string().required("Company is required").nullable().typeError("Company is required"),


  });
  const filterInitialValues = {
    from: date,
    to: date,

  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from.dateForAPI) {
      filters["from"] = details.searchParams.from.dateForAPI;
    }
    if (details.searchParams.to.dateForAPI) {
      filters["to"] = details.searchParams.to.dateForAPI;
    }

  }

  const onFilterRequest = (values) => {
    const fromDate = new Date(values.from);
    const toDate = new Date(values.to);

    if (fromDate.getMonth() !== toDate.getMonth()) {
        setNotify({
            isOpen: true,
            message: "Date should be from the same month.",
            type: "error",
        });
        return;
    }

    const diffInDays = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    

    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
        if (value !== null && value !== "") {
            filterObj[key] = value;
        }
    }
    setFilterValues(filterObj);
};
const clearFilter =()=>{
  filterInitialValues.status = null
  location.reload();
 }
return (
  <>
    <Filter
      filterFields={filterFields}
      initialValues={filterInitialValues}
      onSubmit={onFilterRequest}
      validationSchema={validationSchema}
      onClear={clearFilter}



    />
    <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
                

      </div>
      {filtersApplied ? (

<Table
proxyURL={BO_ACCESS_PORTAL_REPORT_URL}
model={model}
filterValues={filterValues}
noFilter
noAddButton
excelExport={{ fileName: "BackOfficeAccessPortalReport" }}
pdfExport={{ fileName: "BackOfficeAccessPortalReport" }}
paginationDisable = {true}
tableBodyDisable = {true}
/>
) : (

  <Table
  proxyURL={null}
  model={model}
  exportUrl="url"
  filterValues={filterValues}
  noFilter
  excelExport={{ fileName: "BackOfficeAccessPortalReport" }}
  pdfExport={{ fileName: "BackOfficeAccessPortalReport" }}
  paginationDisable = {true}
  tableBodyDisable = {true}
  noAddButton
/>
)}

      
   

  </>
);


};
export default boAccessPortalDetails;

